export const SCOPE_DISPLAY_TEST_ID = 'scope-display';
export const SCOPE_DISPLAY_TOGGLE_TEST_ID = 'scope-display-toggle';
export const SCOPE_DISPLAY_LIST_TEST_ID = 'scope-display-list';
